// TODO: These need to be on the back-end as well. Everything must be stripped and validated on front-end and back-end!

// Validation functions ///////////////////////////////////////////////////////
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const PASSWORD_REGEX = /./;

export const validateEmail = (email) => EMAIL_REGEX.test(email);
export const validatePass = (pass) => PASSWORD_REGEX.test(pass);

// Striping functions /////////////////////////////////////////////////////////
/**
 * Regex that will match anything that is a special character (digits, letters, space)
 */
const SPECIAL_CHAR = /[^a-zA-Z0-9 ]/g;

/**
 * Regex pattern that will match everything except numbers
 */
const NOT_NUM = /[^0-9]/g;

/**
 * Regex pattern that will match everything except letters
 */
const NOT_ALPHA = /[^a-zA-Z ]/g;

/**
 * Strips white space on both ends of string.
 *
 * @param {String} val Values to be stripped of white space on ends
 */
const _trim = (val) => String(val).trim();

/**
 * Strips person's name of anything not alphabetic and whitespace on ends.
 *
 * @param {String} val String value of person's name
 */
export const stripName = (val) => String(val).replace(NOT_ALPHA, '');

/**
 * Strips physical address of special characters and whitespace on ends.
 *
 * @param {String} val String value of physical address
 */
export const stripAddress = (val) => String(val).replace(SPECIAL_CHAR, '');

/**
 * Strips city of special characters and whitespace on ends.
 *
 * @param {String} val String value of city
 */
export const stripCity = (val) => String(val).replace(NOT_ALPHA, '');

export const stripPhone = (val) => _trim(val).replace(NOT_NUM, '');

export const stripPostalCode = (val) =>
  _trim(val)
    .replace(NOT_NUM, '')
    .substr(0, 5);

export const stripPolicyNum = (val) => _trim(val).replace(NOT_NUM, '');

export const stripMoney = (val) =>
  val
    .replace(/[^\d\.]/g, '') // Removes anything not a number nor decimal
    .replace(/(\..*)\./g, '$1') // Removes multiple decimal places if any
    .replace(/\.(\d{2}).+/, '.$1') // Removes 3+ decimal numbers
    .replace(/^0(\d)/, '$1'); // Removes leading 0 if other numbers

// Formatting functions ///////////////////////////////////////////////////////

export const formatMoney = (val) =>
  _trim(val).replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Adds comma for every 3 numbers
// .replace(/(\.\d)$/, '$10'); // Pads end with zero if needed
